<template>
    <drawer
        placement="right"
        title="Ticket"
        :before-close="closeDrawerTicket"
        :value="value" @input="v => $emit('input', v)"
        :width="widthDrawer">
        <ticket ref="ticket" :id="id" :id_projeto="id_projeto" @update="ticket => $emit('update', ticket)" v-if="value && (id || id_projeto)"></ticket>
    </drawer>
</template>

<script>
    import debounce from "lodash/debounce"
    export default {
        props: {
            value: Boolean,
            id: Number,
            id_projeto: Number
        },
        name: "DrawerTicket",
        data() {
            return {
                widthDrawer: 850,
            }
        },
        methods: {
            closeDrawerTicket() {
                return new Promise((resolve) => {
                    if (this.$refs.ticket.ativar_botao) {
                        this.$Modal.confirm({
                            title: 'Há alterações que não foram salvas.',
                            content: 'Deseja realmente fechar?',
                            cancelText: "Não",
                            okText: "Sim",
                            onOk: () => {
                                resolve();
                            },
                        });
                    } else {
                        resolve();
                    }
                });
            },
            verifyWidth(windowWidth) {
                this.widthDrawer = windowWidth < 850 ? windowWidth : 850;
            },
            handleWindowResize: debounce(function (event) {
                this.verifyWidth(event.currentTarget.innerWidth);
            }, 400),
        },
        mounted() {
            this.verifyWidth(window.innerWidth);
            this.$nextTick(() => {
                window.addEventListener('resize', this.handleWindowResize);
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
    }
</script>
